module.exports = __webpack_public_path__ + "img/图1-6  分类任务.f7524984.png";